import { Link, Navigate, useParams } from "react-router-dom";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import { FaArrowLeft, FaWhatsapp } from "react-icons/fa";
import { getComodidadeBySlug, getOutrasComodidades } from "./comodidadesData";
import "./detalhe.css";

const WHATSAPP =
  "https://wa.me/5542933008907?text=Ol%C3%A1!%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20a%20estrutura%20do%20Hotel%20Marechal%20Express.";

export default function EstruturaDetalhe() {
  const { slug } = useParams();
  const item = getComodidadeBySlug(slug || "");

  if (!item) {
    return <Navigate to="/estrutura" replace />;
  }

  const outras = getOutrasComodidades(item.slug);

  return (
    <article className="estrutura-detalhe">
      <header className="estrutura-detalhe__hero">
        <div className="estrutura-detalhe__hero-bg">
          <img
            src={item.imagens[0]}
            alt={`${item.titulo} — imagem de capa`}
            className="estrutura-detalhe__hero-img"
          />
        </div>
        <div className="estrutura-detalhe__hero-veil" />
        <Container className="estrutura-detalhe__hero-inner position-relative">
          <nav className="estrutura-detalhe__breadcrumb" aria-label="Navegação estrutural">
            <Link to="/">Início</Link>
            <span aria-hidden>/</span>
            <Link to="/estrutura">Estrutura</Link>
            <span aria-hidden>/</span>
            <span className="text-white-50">{item.titulo}</span>
          </nav>
          <p className="estrutura-detalhe__eyebrow">{item.titulo}</p>
          <h1 className="estrutura-detalhe__title">{item.tituloHero}</h1>
          <p className="estrutura-detalhe__lead">{item.resumo}</p>
        </Container>
      </header>

      <Container className="py-5">
        {item.notaDestaque && (
          <div className="estrutura-detalhe__alert" data-aos="fade-up" role="note">
            <strong>{item.notaDestaque.titulo}</strong>
            <p className="mb-0 mt-2">{item.notaDestaque.texto}</p>
          </div>
        )}

        <Row className="g-5 mb-5 align-items-start">
          <Col lg={7} data-aos="fade-right">
            <p className="estrutura-detalhe__intro">{item.introducao}</p>
            <ul className="estrutura-detalhe__checklist">
              {item.destaques.map((d) => (
                <li key={d}>{d}</li>
              ))}
            </ul>
          </Col>
          <Col lg={5} data-aos="fade-left">
            <div className="estrutura-detalhe__carousel-wrap hotel-carousel-wrap">
              <Carousel className="hotel-carousel estrutura-detalhe__carousel" controls indicators>
                {item.imagens.map((src, i) => (
                  <Carousel.Item key={i}>
                    <img
                      src={src}
                      alt={`${item.titulo} — imagem ${i + 1}`}
                      className="d-block w-100 estrutura-detalhe__carousel-img"
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          </Col>
        </Row>

        <div className="estrutura-detalhe__blocks">
          {item.blocos.map((bloco, i) => (
            <Row
              key={bloco.titulo}
              className={`g-4 g-lg-5 mb-5 align-items-center ${i % 2 === 1 ? "flex-lg-row-reverse" : ""}`}
              data-aos="fade-up"
            >
              <Col lg={6}>
                <h2 className="h4 font-display mb-3">{bloco.titulo}</h2>
                <p className="text-muted mb-0 estrutura-detalhe__block-text">{bloco.texto}</p>
              </Col>
              <Col lg={6}>
                <div className="estrutura-detalhe__block-accent" aria-hidden />
              </Col>
            </Row>
          ))}
        </div>

        <section className="estrutura-detalhe__cta" data-aos="fade-up">
          <div className="estrutura-detalhe__cta-inner">
            <div>
              <h2 className="h5 font-display text-white mb-2">Pronto para conhecer pessoalmente?</h2>
              <p className="text-white-50 small mb-0 mb-md-2">
                Fale com a recepção ou envie uma mensagem — teremos prazer em atendê-lo.
              </p>
            </div>
            <div className="estrutura-detalhe__cta-actions">
              <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="btn btn-hotel-whatsapp">
                <FaWhatsapp className="me-2" aria-hidden />
                WhatsApp
              </a>
              <Link to="/localizacao" className="btn btn-outline-light btn-sm estrutura-detalhe__btn-outline">
                Como chegar
              </Link>
            </div>
          </div>
        </section>

        <section className="mt-5 pt-4" data-aos="fade-up">
          <h2 className="font-display h4 mb-4">Outras áreas da estrutura</h2>
          <Row className="g-3">
            {outras.map((o) => (
              <Col md={6} lg={3} key={o.slug}>
                <Link to={`/estrutura/${o.slug}`} className="estrutura-detalhe__related">
                  <span className="estrutura-detalhe__related-title">{o.titulo}</span>
                  <span className="estrutura-detalhe__related-arrow" aria-hidden>
                    →
                  </span>
                </Link>
              </Col>
            ))}
          </Row>
        </section>

        <div className="text-center mt-5">
          <Link to="/estrutura" className="estrutura-detalhe__back">
            <FaArrowLeft className="me-2" aria-hidden />
            Voltar à visão geral da estrutura
          </Link>
        </div>
      </Container>
    </article>
  );
}
